import BIForm from '../form/form';

export function initializeLoginForms() {
    let LoginForm = new BIForm({
        form_id: `.loginForm`
    });

    let ValidationForm = new BIForm({
        form_id: `.validationForm`
    });

    let ForgotPasswordForm = new BIForm({
        form_id: `.forgotPasswordForm`
    });

    $(".loginSection .goBack").on('click', function () {
        resetLoginForm();
    });

    function showPasswordLoginForm() {
        $('.loginForm .passwordContainer').removeClass('hidden');
        LoginForm.setAction("/auth/login-user-form-submit");
        $('.signinButton').removeClass('hidden');
        $('.continueButton').addClass('hidden');
        $('.emailForm').removeClass('hidden');
        $(".loginForm .goBack").removeClass('hidden');
        $(".signinButton").html("Sign In");
        $(".forgotPassword").removeClass('hidden');
    }

    function showEmailVerifyForm(verifyFor = null) {
        $('.validationForm').removeClass('hidden');
        if(verifyFor){
            $('.validationForm input[name="verifyFor"]').val(verifyFor);
        }
        $('.loginForm').addClass('hidden');
        $('.continueButton').addClass('hidden');
        $('.emailForm').addClass('hidden');
        $('.emailCode').text($('.loginForm #email').val());
        $('.loginContainer h3').addClass("hidden");
        $(".validationCodeWrapper input").val('');
    }

    function showForgottenPasswordForm() {
        $('.validationForm').addClass('hidden');
        $(".forgotPasswordForm").removeClass('hidden');
    }

    function resetLoginForm() {
        LoginForm.setAction("/auth/login-check");
        $('.loginForm .passwordContainer').addClass('hidden');
        $('.validationForm').addClass('hidden');
        $('.signinButton').addClass('hidden');
        $('.continueButton').removeClass('hidden');
        $('.emailForm').removeClass('hidden');
        $(".loginForm .goBack").addClass('hidden');
        $(".forgotPassword").addClass('hidden');
        $('.loginContainer h3').removeClass("hidden");
        $('.loginForm').removeClass('hidden');
        $("body").css("cursor", "default");
        $(".forgotPasswordForm").addClass('hidden');
    }

    $(document).on('click', '.forgotPassword', function (e) {
        resetLoginForm();
        showEmailVerifyForm('forgotPassword');
        axios({
            method: 'POST',
            url: '/verify-email/resend-code'
        })
        .then(function (response) {
        })
        .catch(function (error) {
        });
    });


    $(document).on('click', '.resendCode button', function (e) {
        e.preventDefault();

        ValidationForm.turnFormLoadingOn();
        $("body").css("cursor", "progress");

        axios({
            method: 'POST',
            url: '/verify-email/resend-code'
        })
            .then(function (response) {
                ValidationForm.turnFormLoadingOff();
                $("body").css("cursor", "default");
            })
            .catch(function (error) {
            });
    });

    LoginForm.addSubmitListener((response) => {

        if (!response.success || response.success !== true) {
            LoginForm.turnFormLoadingOff();
            $("body").css("cursor", "default");
            LoginForm.showErrors(response.data);
        } else {
            if (response.redirect) {
                if (response.data === 'MS_AUTH_REDIRECT') {
                    window.location.href = response.redirect;
                    return;
                }
                if (response.data === 'AUTH_SUCCESS') {
                    const redirectUrl = localStorage.getItem('redirect_after_login');
                    if (redirectUrl) {
                        localStorage.removeItem('redirect_after_login');
                        window.location.href = redirectUrl;
                        return;
                    } else {
                        window.location.href = response.redirect;
                        return;
                    }
                } else {
                    window.location.reload();
                    return;
                }
            } else {
                LoginForm.turnFormLoadingOff();
                $("body").css("cursor", "default");
                
                if (response.data === 'SHOW_PASSWORD') {
                    resetLoginForm();
                    showPasswordLoginForm();
                }

                if (response.data === 'SHOW_VALIDATION') {
                    resetLoginForm();
                    showEmailVerifyForm('login');
                }
            }
        }
    },
        () => {
            $("body").css("cursor", "progress"); return true;
        });

    ValidationForm.addSubmitListener((response) => {

        if(response.data === "VERIFY_FORGOT_SUCCESS") {
            showForgottenPasswordForm();
        } else {
            if (response.success) {
                window.location.href = response.data.redirect;
            } else {
                $(".validationCodeWrapper input").val('');
                alert('The code is invalid or has expired, please try again');
                ValidationForm.turnFormLoadingOff();
                showEmailVerifyForm();
            }
        }
        
    });

    const KEYBOARDS = {
        backspace: 8,
        arrowLeft: 37,
        arrowRight: 39,
    };

    const $form = $('.loginSection .validationForm');
    const $inputs = $form.find('input[type="text"]');

    function handleInput(e) {
        const $input = $(e.target);
        const $nextInput = $input.next('input');
        if ($nextInput.length && $input.val()) {
            $nextInput.focus();
            if ($nextInput.val()) {
                $nextInput.select();
            }
        }
    }

    function handlePaste(e) {
        e.preventDefault();
        const paste = e.originalEvent.clipboardData.getData('text');
        $inputs.each(function (i, input) {
            $(input).val(paste[i] || '');
        });
    }

    function handleBackspace(e) {
        const $input = $(e.target);
        if ($input.val()) {
            $input.val('');
            return;
        }
        $input.prev('input').focus();
    }

    function handleArrowLeft(e) {
        const $prevInput = $(e.target).prev('input');
        if ($prevInput.length) {
            $prevInput.focus();
        }
    }

    function handleArrowRight(e) {
        const $nextInput = $(e.target).next('input');
        if ($nextInput.length) {
            $nextInput.focus();
        }
    }

    $form.on('input', 'input[type="text"]', handleInput);
    $inputs.first().on('paste', handlePaste);

    $inputs.each(function () {
        const $input = $(this);

        $input.on('focus', function (e) {
            setTimeout(() => {
                $(e.target).select();
            }, 0);
        });

        $input.on('keydown', function (e) {
            switch (e.which) {
                case KEYBOARDS.backspace:
                    handleBackspace(e);
                    break;
                case KEYBOARDS.arrowLeft:
                    handleArrowLeft(e);
                    break;
                case KEYBOARDS.arrowRight:
                    handleArrowRight(e);
                    break;
                default:
                // Do nothing
            }
        });
    });

    ForgotPasswordForm.addSubmitListener((response) => {
        if (response.success) {
            ForgotPasswordForm.turnFormLoadingOff();
            ForgotPasswordForm.form[0].reset();
            ForgotPasswordForm.showSuccess(response.message);

            setTimeout(() => {
                resetLoginForm();
                showPasswordLoginForm();
            }, 2000);
        }
    });

    $(document).on('click', '.loginLink', function (e) {
        const fullUrlWithAnchor = window.location.href;
        localStorage.setItem('redirect_after_login', fullUrlWithAnchor);
    });
}
